import { createAsyncActionType } from './types';

export const GET_CERTIFICATION_DETAILS = createAsyncActionType(
  'CERTIFICATION',
  'GET_CERTIFICATION_DETAILS',
);
